module.exports = __webpack_public_path__ + "img/minus.651096e3.svg";